import moment from "moment/moment";
import {MONGO_DATE_FORMAT} from "../utils/date";
import {Timetable} from "../types/Timetable";

export class TimetableDecorator {
    private readonly timetable: Timetable;

    constructor(timetable: Timetable) { // <-- Use new type
        this.timetable = {...timetable};
    }

    private getMomentDate(date: string): moment.Moment | null {
        const momentDate = moment(date, MONGO_DATE_FORMAT, true);
        return momentDate.isValid() ? momentDate : null;
    }

    getStartDate = (): moment.Moment | null => {
        const date = this.timetable.startDate;
        return date ? this.getMomentDate(date) : null;
    }

    getEndDate = (): moment.Moment | null => {
        const date = this.timetable.endDate;
        return date ? this.getMomentDate(date) : null;
    }

    // --- UPDATED from _id ---
    getTimetableId = (): string => this.timetable.id;

    // All other methods remain identical
    getTitle = (): string => this.timetable.title;
    getScheduling = (): number => this.timetable.scheduling;
    getTimeFormat = (): number => this.timetable.timeFormat;
    getNumberOfWeeks = (): number => Math.max(this.timetable.numberOfWeeks, 1);
    getStartWeek = (): number => Math.max(this.timetable.startWeek, 0);
    getStartWeekDate = (): moment.Moment | null => this.getMomentDate(this.timetable.startWeekDate);
    getShiftStartDay = (): moment.Moment | null => this.getMomentDate(this.timetable.shiftStartDay);
    getShiftNumberOfDays = (): number => Math.max(this.timetable.shiftNumberOfDays, 1);
    getNumberOfPeriods = (): number => Math.max(this.timetable.numberOfPeriods, 2);

    getShiftDaysOfWeek(): Set<number> {
        const set = new Set<number>();
        // This logic works fine as 'shift_days_of_week' is now number[]
        this.timetable.shiftDaysOfWeek?.forEach(day => {
            if (day) set.add(day);
        });
        return set;
    }

    getWeekNames(): Map<number, string> {
        /*
        this.timetable.week_data_list?.forEach(week => {
            if (week && week.name) {
                map.set(week.index_of_week, week.name)
            }
        });
         */
        return new Map<number, string>();
    }
}

// These constants remain identical
export const Scheduling = Object.freeze({
    WEEKLY: 1,
    SHIFT: 3
})

export const TimeFormat = Object.freeze({
    HOUR: 1,
    PERIOD: 2
})